import { Temporal } from 'temporal-polyfill';

import { DayOfWeek, DayOfWeekLabelMap } from './data/meeting-block.js';

const temporalDayOfWeekToEnum = {
  1: DayOfWeek.monday,
  2: DayOfWeek.tuesday,
  3: DayOfWeek.wednesday,
  4: DayOfWeek.thursday,
  5: DayOfWeek.friday,
  6: DayOfWeek.saturday,
  7: DayOfWeek.sunday,
} as const;

export function dayOfWeekFromTemporal({ dayOfWeek }: Temporal.PlainDate): DayOfWeek {
  return temporalDayOfWeekToEnum[dayOfWeek as keyof typeof temporalDayOfWeekToEnum]!;
}

export function nextPlainDateOnDayOfWeek(today: Temporal.PlainDate, targetDay: DayOfWeek): Temporal.PlainDate {
  const currentDay = today.dayOfWeek % 7;
  const targetDayNumber = DayOfWeekLabelMap[targetDay].day;
  const daysUntilTarget = (targetDayNumber + 7 - currentDay) % 7 || 7;

  return today.add({ days: daysUntilTarget });
}

/** Monday of the Monday–Sunday week containing `plainDate`. */
export function startOfWeekPlainDate(plainDate: Temporal.PlainDate): Temporal.PlainDate {
  return plainDate.subtract({ days: plainDate.dayOfWeek - 1 });
}
